"use strict";
// 聊天工具函数与业务逻辑模块
Object.defineProperty(exports, "__esModule", { value: true });
exports.printTerminalTable = exports.padEndDisplay = exports.getDisplayWidth = void 0;
exports.loadSavedConfig = loadSavedConfig;
exports.saveConfig = saveConfig;
exports.openBrowser = openBrowser;
exports.handleConfigReuse = handleConfigReuse;
exports.setupConnection = setupConnection;
exports.fetchAndSelectModels = fetchAndSelectModels;
exports.saveAndPrintConfig = saveAndPrintConfig;
exports.runChatLoop = runChatLoop;
const cli_core_1 = require("@/cli-core");
const ai_util_1 = require("@/service/ai-util");
const cli_api_1 = require("@/cli-api");
const types_1 = require("@/types");
/**
 * 计算字符串在终端中的实际显示宽度
 */
const getDisplayWidth = (str) => ai_util_1.AIUtil.getDisplayWidth(str);
exports.getDisplayWidth = getDisplayWidth;
/**
 * 根据实际显示宽度进行右侧填充对齐
 */
const padEndDisplay = (str, targetWidth) => ai_util_1.AIUtil.padEndDisplay(str, targetWidth);
exports.padEndDisplay = padEndDisplay;
/**
 * 通用终端动态表格打印函数
 */
const printTerminalTable = (title, headers, rows) => {
    ai_util_1.AIUtil.printTerminalTable(title, headers, rows);
};
exports.printTerminalTable = printTerminalTable;
/**
 * 加载本地保存的 AI 配置
 */
function loadSavedConfig() {
    return ai_util_1.AIUtil.loadSavedAISetting();
}
/**
 * 保存 AI 配置到 commands.json 文件中
 */
function saveConfig(settings) {
    ai_util_1.AIUtil.saveAISetting(settings);
}
/**
 * 跨平台打开浏览器访问指定链接
 */
async function openBrowser(url) {
    await ai_util_1.AIUtil.openBrowser(url);
}
/**
 * 处理已有配置的复用逻辑
 */
async function handleConfigReuse(savedConfig) {
    if (!savedConfig || !savedConfig.baseUrl || !savedConfig.model) {
        return { reused: false };
    }
    const ctxNum = savedConfig.options?.contextSize || 32768;
    const ctxLabel = `${Math.round(ctxNum / 1024)}k`;
    if (savedConfig.options?.architectureModel) {
        (0, exports.printTerminalTable)(`📋 AI 当前配置 (多模型协作)`, ['AI服务网关', '设计模型', '编码模型', '上下文大小'], [[savedConfig.baseUrl, savedConfig.options.architectureModel, savedConfig.model, ctxLabel]]);
    }
    else {
        (0, exports.printTerminalTable)(`📋 AI 当前配置`, ['AI服务网关', '模型', '上下文大小'], [[savedConfig.baseUrl, savedConfig.model, ctxLabel]]);
    }
    const reuseAns = await cli_core_1.CLI.addQuestions([
        {
            type: 'confirm',
            name: 'reuse',
            message: `检测到已有配置(见上面表格)，是否继续使用？`,
            default: true,
        },
    ]);
    if (reuseAns.reuse) {
        let enableMultiModel = savedConfig.options?.architectureModel ? true : false;
        let architectureModel = savedConfig.options?.architectureModel || '';
        let implementationModel = savedConfig.model;
        let options = { ...savedConfig.options };
        cli_core_1.CLI.loading.info('已直接复用现有 AI 配置。');
        return {
            reused: true,
            baseUrl: savedConfig.baseUrl,
            apiKey: savedConfig.apiKey || '',
            model: savedConfig.model,
            agentServerUrl: savedConfig.agentServerUrl || 'http://127.0.0.1:10086',
            options,
            enableMultiModel,
            architectureModel,
            implementationModel,
        };
    }
    return { reused: false };
}
/**
 * 交互式引导：设置协议与连接网关
 */
async function setupConnection(savedConfig) {
    const defaultBaseUrl = 'http://127.0.0.1:11434';
    const connectionAns = await cli_core_1.CLI.addQuestions([
        {
            type: 'input',
            name: 'baseUrl',
            message: '请输入大模型部署服务地址 (Base URL):',
            default: savedConfig?.baseUrl || defaultBaseUrl,
            validate: async (value) => {
                try {
                    new URL(value);
                }
                catch {
                    return '格式错误：请输入合法的网址（例如：http://127.0.0.1:11434）';
                }
                return true;
            },
        },
        {
            type: 'input',
            name: 'apiKey',
            message: '请输入密钥 (API Key，若服务器无需鉴权可直接回车):',
            default: savedConfig?.apiKey || '',
        },
    ]);
    const baseUrl = connectionAns.baseUrl;
    const apiKey = connectionAns.apiKey || '';
    cli_core_1.CLI.loading.info(`正在检测 ollama 服务连通性 (${baseUrl})...`);
    const isOnline = await ai_util_1.AIUtil.verifyOllamaServiceConnection(baseUrl);
    if (!isOnline) {
        cli_core_1.CLI.loading.fail('检测到 Ollama 未服务运行，请先启动ollama服务...');
        process.exit(0);
    }
    cli_core_1.CLI.loading.succeed('Ollama 服务连接成功');
    return { baseUrl, apiKey };
}
/**
 * 拉取远程模型列表并交互式选择模型协作模式
 */
async function fetchAndSelectModels(baseUrl, apiKey) {
    let modelList = [];
    const tagsUrl = `${baseUrl.replace(/\/$/, '')}/api/tags`;
    const tagsRes = await cli_api_1.request.ajax(tagsUrl, 'get');
    if (tagsRes && tagsRes.data && tagsRes.data.models) {
        modelList = tagsRes.data.models.map((m) => m.name || m.id);
    }
    else if (Array.isArray(tagsRes)) {
        modelList = tagsRes.map((m) => m.name || m.id || m);
    }
    if (modelList.length === 0) {
        cli_core_1.CLI.loading.fail(`ollama 服务中没有模型，请使用 "coda setup ollama --model=XXX" 拉取模型`);
        process.exit(0);
    }
    const modelRows = modelList.map((m, idx) => [`[${idx + 1}]`, m]);
    (0, exports.printTerminalTable)('可用 AI 模型列表', ['序号', '模型名称'], modelRows);
    const modelChoices = modelList.map((m) => ({ name: m, value: m }));
    const modeAnswers = await cli_core_1.CLI.addQuestions([
        {
            type: 'confirm',
            name: 'enableMultiModel',
            message: '是否启用多模型协作 (架构规划 + 代码实现)?',
            default: false,
        },
    ]);
    const enableMultiModel = modeAnswers.enableMultiModel;
    let architectureModel = modelList[1] || modelList[0];
    let implementationModel = modelList[0];
    let model = modelList[0];
    let taskMode = 'coding';
    if (enableMultiModel) {
        const archAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'architectureModel',
                message: '请选择 1. 架构设计模型:',
                choices: modelChoices,
                default: architectureModel,
            },
        ]);
        architectureModel = archAnswers.architectureModel;
        const implAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'implementationModel',
                message: '请选择 2. 代码实现模型:',
                choices: modelChoices,
                default: implementationModel,
            },
        ]);
        implementationModel = implAnswers.implementationModel;
        model = implAnswers.implementationModel;
    }
    else {
        const singleAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'select',
                name: 'model',
                message: '请选择要调用的 AI 模型:',
                choices: modelChoices,
                default: implementationModel,
            },
            {
                type: 'select',
                name: 'taskMode',
                message: '请选择工作模式:',
                choices: [
                    { name: '💻 代码实现 (Coding)', value: 'coding' },
                    { name: '🔍 代码审查 (Code Review)', value: 'review' },
                ],
                default: 'coding',
            },
        ]);
        model = singleAnswers.model;
        taskMode = singleAnswers.taskMode;
    }
    return { modelList, enableMultiModel, architectureModel, implementationModel, model, taskMode };
}
/**
 * 交互式选择模型上下文大小，持久化保存配置并打印终端配置表格
 */
async function saveAndPrintConfig(currentSettings) {
    const contextAnswers = await cli_core_1.CLI.addQuestions([
        {
            type: 'select',
            name: 'contextSize',
            message: '请选择模型上下文大小 (Context Size):',
            choices: [
                { name: '8K (8192)', value: 8192 },
                { name: '16K (16384)', value: 16384 },
                { name: '32K (32768) [推荐]', value: 32768 },
                { name: '64K (65536)', value: 65536 },
                { name: '128K (131072)', value: 131072 },
            ],
            default: 32768,
        },
    ]);
    const contextSize = Number(contextAnswers.contextSize);
    currentSettings.options.contextSize = contextSize;
    currentSettings.options.architectureModel = currentSettings.options.architectureModel
        ? currentSettings.options.architectureModel
        : undefined;
    saveConfig(currentSettings);
    const savedCtxLabel = `${Math.round(contextSize / 1024)}k`;
    if (currentSettings.options.architectureModel) {
        (0, exports.printTerminalTable)(`📋 AI配置已保存 (多模型协作)`, ['AI服务网关', '设计模型', '编码模型', '上下文大小'], [
            [
                currentSettings.baseUrl,
                currentSettings.options.architectureModel,
                currentSettings.model,
                savedCtxLabel,
            ],
        ]);
    }
    else {
        (0, exports.printTerminalTable)(`📋 AI配置已保存`, ['AI服务网关', '模型', '上下文大小'], [[currentSettings.baseUrl, currentSettings.model, savedCtxLabel]]);
    }
    cli_core_1.CLI.loading.succeed('AI 模型配置已成功写入项目配置文件。');
    return contextSize;
}
/**
 * 核心流式对话循环
 */
async function runChatLoop(settings, taskMode) {
    cli_core_1.CLI.loading.start('正在连接至 Coda Agent Server 运行环境...');
    try {
        const { online } = await cli_api_1.PM2.getServerStatusWithPM2(types_1.ServerNames.agnet);
        if (!online) {
            cli_core_1.CLI.loading.info('Coda Agent Server 未在后台运行，正在自动启动...');
            const agentStarted = await ai_util_1.AIUtil.startAgentWithPM2();
            if (agentStarted) {
                cli_core_1.CLI.loading.succeed('Coda Agent Server连接成功');
            }
            else {
                cli_core_1.CLI.loading.fail('Coda Agent Server连接异常');
                process.exit(0);
            }
        }
        else {
            cli_core_1.CLI.loading.succeed('Coda Agent Server 连接成功');
        }
    }
    catch (err) {
        cli_core_1.CLI.loading.fail(`连接 Coda Agent Server 失败: ${err.message}`);
        process.exit(0);
    }
    let isRunning = true;
    let success = false;
    while (isRunning) {
        const inputAnswers = await cli_core_1.CLI.addQuestions([
            {
                type: 'input',
                name: 'userPrompt',
                message: '💬 请输入任务需求 (输入 "退出" 结束):',
                default: '',
            },
        ]);
        const rawInput = (inputAnswers.userPrompt || '').trim();
        if (rawInput === '退出') {
            cli_core_1.CLI.loading.info('正在退出 AI 编程助手，再见！');
            isRunning = false;
            success = true;
            break;
        }
        if (!rawInput) {
            continue;
        }
        cli_core_1.CLI.loading.info('AI 思考与工具调用中...');
        let firstChunkReceived = false;
        try {
            const targetUrl = `${settings.agentServerUrl.replace(/\/$/, '')}/api/chat/completions`;
            const requestBody = { settings, prompt: rawInput };
            const res = await fetch(targetUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(requestBody),
            });
            if (!res.ok || !res.body) {
                throw new Error(`连接 coda-server 失败: 状态码 ${res.status}`);
            }
            const reader = res.body.getReader();
            const decoder = new TextDecoder('utf-8');
            while (true) {
                const { done, value } = await reader.read();
                if (done)
                    break;
                const chunk = decoder.decode(value, { stream: true });
                if (chunk) {
                    if (!firstChunkReceived) {
                        firstChunkReceived = true;
                        cli_core_1.CLI.loading.info('AI 响应开始流式传输...');
                    }
                    process.stdout.write(chunk);
                }
            }
            if (!firstChunkReceived) {
                cli_core_1.CLI.loading.succeed('AI 响应完成');
            }
            console.log('\n');
        }
        catch (err) {
            cli_core_1.CLI.loading.fail(`AI 任务执行出错: ${err.message}`);
        }
    }
    return success;
}
